import { render, staticRenderFns } from "./GeneralMenu.vue?vue&type=template&id=4f3ea3b7&"
import script from "./GeneralMenu.vue?vue&type=script&lang=ts&"
export * from "./GeneralMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports